export const LOADING = 'LOADING';
export const MESSAGE = 'MESSAGE';
export const LOADING_ACTIVATION = 'LOADING_ACTIVATION';
export const LIST_INTEGRATIONS = 'LIST_INTEGRATIONS';
export const LIST_WOOCOMMERCE_STORES = 'LIST_WOOCOMMERCE_STORES';
export const LIST_MERCADOFLEX_STORES = 'LIST_MERCADOFLEX_STORES';